/** Demo rows mirrored from quantum-webapp admin.html (UI scaffold until live APIs). */

export const SUBSCRIBERS = [
  { email: 'obrescia@gmc-ideas.com', product: 'Superstars · Tier 1', lastPayment: '$0', period: 'monthly', status: 'trialing', renewal: 'Oct 11, 2026' },
  { email: 'obrescia@gmc-ideas.com', product: 'Echo · SPY & QQQ · Tier 2', lastPayment: '$0', period: 'monthly', status: 'trialing', renewal: 'Oct 11, 2026' },
  { email: 'lbuell777@yahoo.com', product: 'Superstars · Tier 1', lastPayment: '$0', period: 'monthly', status: 'trialing', renewal: 'Sep 04, 2026' },
  { email: 'mabell.007@gmail.com', product: 'Superstars · Tier 1', lastPayment: '$0', period: 'monthly', status: 'trialing', renewal: 'Aug 07, 2026' },
  { email: 'klharris85@hotmail.com', product: 'Superstars · Tier 1', lastPayment: '$0', period: 'monthly', status: 'trialing', renewal: 'Aug 04, 2026' },
  { email: 'klharris74@gmail.com', product: 'Echo · SPY & QQQ · Tier 2', lastPayment: '$0', period: 'monthly', status: 'trialing', renewal: 'Sep 03, 2026' },
  { email: 'chris@jtncgroup.com', product: 'Echo · SPY & QQQ · Tier 1', lastPayment: '$197', period: 'monthly', status: 'active', renewal: 'Jul 26, 2026' },
  { email: 'natita@jtncgroup.com', product: 'Superstars · Tier 1', lastPayment: '$157', period: 'monthly', status: 'active', renewal: 'Jul 20, 2026' },
  { email: 'bevin_j@yahoo.com', product: 'Echo · SPY & QQQ · Tier 1', lastPayment: '$297', period: 'monthly', status: 'cancelled', renewal: 'Cancelled Jun 05, 2026' },
  { email: 'moorea001@gmail.com', product: 'Echo · SPX · Tier 1', lastPayment: '$297', period: 'monthly', status: 'active', renewal: 'Jul 18, 2026' },
];

export const USERS = [
  { email: 'chris@jtncgroup.com', name: 'Chris Anthony', role: 'ADMIN', status: 'active', created: 'Jun 14, 2026' },
  { email: 'obrescia@gmc-ideas.com', name: 'Olympia Brescia', role: 'USER', status: 'active', created: 'Jun 13, 2026' },
  { email: 'klharris85@hotmail.com', name: 'Kenneth Harrison', role: 'USER', status: 'active', created: 'May 06, 2026' },
  { email: 'bevin_j@yahoo.com', name: 'Bevin Johnson', role: 'USER', status: 'active', created: 'May 05, 2026' },
  { email: 'clarkjtnc@gmail.com', name: 'Delores Byrd', role: 'USER', status: 'active', created: 'Apr 28, 2026' },
  { email: 'lbuell777@yahoo.com', name: 'Louis Buell', role: 'USER', status: 'active', created: 'Apr 28, 2026' },
  { email: 'mabell.007@gmail.com', name: 'Mitchel Bell', role: 'USER', status: 'active', created: 'Apr 27, 2026' },
  { email: 'clarkjtnc@outlook.com', name: 'Delores Byrd', role: 'USER', status: 'active', created: 'Apr 27, 2026' },
  { email: 'moorea001@gmail.com', name: 'Andrew Moore', role: 'USER', status: 'active', created: 'Apr 27, 2026' },
  { email: 'rappel.plume847@eagereverest.com', name: 'Michael Gallagher', role: 'USER', status: 'active', created: 'Apr 27, 2026' },
];

export const TRADE_LOGS = [
  { accountId: '6YA12491', email: 'adefrenza@dmmlaw.net', count: 13 },
  { accountId: '6YB49406', email: 'mabell007@gmail.com', count: 14 },
  { accountId: '6YB57671', email: 'natita@jtncgroup.com', count: 6 },
  { accountId: '6YB59274', email: 'chris@jtncgroup.com', count: 18 },
  { accountId: '6YB60082', email: 'aaronsgone@yahoo.co.uk', count: 14 },
  { accountId: '6YB60758', email: 'mowunmi@gmail.com', count: 14 },
  { accountId: '6YB61097', email: 'viviano8274@gmail.com', count: 14 },
  { accountId: '6YB61116', email: 'scottvolkers@gmail.com', count: 11 },
  { accountId: '6YB61197', email: 'dante.estwick@gmail.com', count: 14 },
  { accountId: '6YB62300', email: 'jenitaj@msn.com', count: 6 },
  { accountId: '6YB62302', email: 'mbjusa@gmail.com', count: 14 },
  { accountId: '6YB62319', email: 'aajjmayo@gmail.com', count: 6 },
  { accountId: '6YB62363', email: 'moramsey.np@gmail.com', count: 6 },
];

export const INITIAL_TICKERS = {
  superstars: [
    'AAL', 'AAPL', 'ADBE', 'AFRM', 'AMD', 'AMZN', 'ANET', 'APLD', 'ARKK', 'ARM', 'ASTS', 'AVGO', 'BA', 'BABA', 'BAC',
    'C', 'CCL', 'CHWY', 'CLF', 'CLSK', 'CMG', 'COIN', 'CORZ', 'COST', 'CRCL', 'CRM', 'CRWV', 'CSCO', 'CVNA', 'CVX',
    'DAL', 'DELL', 'DIA', 'DIS', 'DKNG', 'EEM', 'EWZ', 'F', 'FCX', 'GDX', 'GLD', 'GM', 'GOOG', 'GS', 'HD', 'HIMS',
    'HOOD', 'IBIT', 'INTC', 'IONQ', 'IREN', 'IWM', 'JETS', 'JPM', 'KO', 'KRE', 'KWEB', 'LLY', 'LYFT', 'MARA', 'MCD',
    'META', 'MO', 'MRVL', 'MS', 'MSFT', 'MSTR', 'MU', 'NCLH', 'NEM', 'NFLX', 'NKE', 'NVDA', 'NVO', 'OKLO', 'ORCL',
    'OXY', 'PANW', 'PDD', 'PEP', 'PFE', 'PLTR', 'QBTS', 'QCOM', 'QQQ', 'QUBT', 'RBLX', 'RDDT', 'RGTI', 'RIOT',
    'RIVN', 'RKLB', 'RUN', 'SBUX', 'SCHW', 'SLV', 'SMCI', 'SMH', 'SNOW', 'SOFI', 'SPY', 'T', 'TGT', 'TSLA', 'TSM',
    'TTD', 'U', 'UAL', 'UBER', 'UNH', 'UPS', 'V', 'VZ', 'WFC', 'WMT', 'XLE', 'XLF', 'XOM', 'XRT', 'XYZ',
  ],
  echo: ['SPY', 'QQQ'],
  spx: ['SPX'],
};

export const BOT_NAMES = {
  superstars: 'Superstars',
  echo: 'Echo · SPY & QQQ',
  spx: 'Echo · SPX',
};
